import { appNetworkManager } from './network-manager';

export const getNewsCategories = () => appNetworkManager.get('/news_category');
export const getNewsFeed = (categoryId: number, page: number) =>
  appNetworkManager.post(`/newsfeed?page=${page}`, { category_id: categoryId });

export const getSingleNewsFeed = (id: number) => appNetworkManager.get(`/newsfeed/${id}`);

export const getNotifications = () => appNetworkManager.get(`/notifications`);
